import React from "react";
import { format } from "date-fns";
import { inspectionRowWrapper, linkStyle } from '../styles';

export const IncidentRow = ({ incident }) => {

  return (
    <tr style={inspectionRowWrapper}>
      <td>{incident.incident_type}</td>
      <td>{incident.property_name} {incident.unit_number || ''}</td>
      <td>
        <a style={linkStyle}>
          {incident.submitted_by}
        </a>
      </td>
      <td>{incident.description}</td>
      <td>
        {format(incident.incident_datetime, 'MM/dd/yyyy hh:mm')}
      </td>
    </tr >
  )
}